import { Component, OnInit, ViewChild } from "@angular/core";
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService } from "primeng/api";
import { EntityListComponent } from "app/components/entity-list/entity-list.component";
import { Rest } from "app/rest/rest_client";
import { VehicleCategoryFormComponent } from "../vehicle-category-form/vehicle-category-form.component";
import { VehicleversioncategoryService } from "app/rest/vehicleversioncategory.service";
import { NotificationsService } from "app/services/notifications-service/notifications.service";
import { I18nService } from "app/services/i18n/i18n.service";
import { AuthenticationService } from "app/core/services/authentication/authentication.service";
import { TranslateService } from "@ngx-translate/core";
import { ExcelService } from "app/services/excel-service/excel.service";

@Component({
    selector: 'app-vehicle-category-list',
    templateUrl: './vehicle-category-list.component.html',
    styleUrls: ['./vehicle-category-list.component.css'],
    providers: [VehicleversioncategoryService, ExcelService],
    standalone: false
})
export class VehicleCategoryListComponent extends EntityListComponent<Rest.VehicleVersionCategory> implements OnInit {

  @ViewChild(VehicleCategoryFormComponent, { static: true })
  vehicleCategoryForm: VehicleCategoryFormComponent;

  user: Rest.User;
  optionsdeleted: any[];
  canCreate: boolean;
  canUpdate: boolean;
  canDisable: boolean;
  canView: boolean;

  constructor(
    public vehicleCategoryService: VehicleversioncategoryService,
    protected confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
    protected i18n: I18nService,
    authenticationService: AuthenticationService,
    protected loadingService: LoadingService,
    protected userTime: UserTimePipe,
    protected translateService: TranslateService,
    protected excelService: ExcelService,
  ) {
    super(
      vehicleCategoryService,
      confirmationService,
      notificationsService,
      i18n,
      authenticationService,
      loadingService,
      userTime,
      excelService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.form = this.vehicleCategoryForm;
    this.hasEntityFilters = false;
    /*Permissions */
    this.user = this.authenticationService.user;
    this.canCreate = this.user.rolesProfiles.some(rp => rp.profile.actions.some(a => a.name === 'VEHICLE_CATEGORY_CREATE'));
    this.canUpdate = this.user.rolesProfiles.some(rp => rp.profile.actions.some(a => a.name === 'VEHICLE_CATEGORY_UPDATE'));
    this.canDisable = this.user.rolesProfiles.some(rp => rp.profile.actions.some(a => a.name === 'VEHICLE_CATEGORY_DISABLE'));
    this.canView = this.user.rolesProfiles.some(rp => rp.profile.actions.some(a => a.name === 'VEHICLE_CATEGORY_VIEW'));
    /** */
    this.optionsdeleted = [
      { label: this.translateService.instant('general.disabled'), value: false },
      { label: this.translateService.instant('general.active'), value: true }
    ];
  }

  protected beforeLoad(): void {
    this.paginationRequest.filters["client"] = [this.user.client.id.toString()];
    if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
      this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
    }
  }

  editIfAllowed(category: Rest.VehicleVersionCategory): void {
    if (!this.canUpdate) {
      return;
    }
    this.editDialog(category);
  }

}
